export default __webpack_public_path__ + "apply12b15f10.png";